module.exports = __webpack_public_path__ + "img/bgEn.a47d0b62.png";